import React, { useState, useEffect, useCallback } from "react";
import { auth, googleProvider } from "../firebase"; // Adjust import path as needed
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";

function CalendarApp() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Set required scopes for Google Calendar
  useEffect(() => {
    // Add the Calendar API scope to your googleProvider
    googleProvider.addScope(
      "https://www.googleapis.com/auth/calendar.readonly"
    );
  }, []);

  // Get Google access token
  const getGoogleAccessToken = useCallback(async () => {
    try {
      let accessToken = localStorage.getItem("accessTokenGoogle");
      console.log("Access token is: ", accessToken);

      if (!accessToken) {
        const result = await signInWithPopup(auth, googleProvider);
        const credential = GoogleAuthProvider.credentialFromResult(result);
        accessToken = credential.accessToken;

        console.log("New Google access token retrieved");
        localStorage.setItem("accessTokenGoogle", accessToken);
      }

      return accessToken;
    } catch (error) {
      console.error("Error getting Google access token:", error);
      return null;
    }
  }, []);

  // Fetch calendar events
  const fetchCalendarEvents = useCallback(async (accessToken) => {
    const response = await fetch(
      "https://www.googleapis.com/calendar/v3/calendars/primary/events?maxResults=1000&orderBy=startTime&singleEvents=true",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Google Calendar API error: ${response.status}`);
    }

    return await response.json();
  }, []);

  // Load events when component mounts
  useEffect(() => {
    async function loadEvents() {
      try {
        setLoading(true);
        const token = await getGoogleAccessToken();

        if (!token) {
          throw new Error("Failed to get access token");
        }

        const calendarData = await fetchCalendarEvents(token);
        setEvents(calendarData.items || []);
      } catch (err) {
        setError(err.message);
        console.error("Failed to load events:", err);
      } finally {
        setLoading(false);
      }
    }

    loadEvents();
  }, [getGoogleAccessToken, fetchCalendarEvents]);

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  // Render loading state
  if (loading) {
    return <div>Loading your calendar events...</div>;
  }

  // Render error state
  if (error) {
    return <div>Error loading calendar: {error}</div>;
  }

  // Render events
  return (
    <div className="calendar-container">
      <h1>My Calendar Events</h1>
      {events.length === 0 ? (
        <p>No events found</p>
      ) : (
        <div className="events-list">
          {events.map((event) => (
            <div key={event.id} className="event-card">
              <h3>{event.summary}</h3>
              <p>
                <strong>Start:</strong>{" "}
                {event.start.date || formatDate(event.start.dateTime)}
              </p>
              {event.description && <p>{event.description}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CalendarApp;
